import React, { useEffect, useState } from "react";

import SubscriptionsTable from "subscriptions/components/SubscriptionsTable";
import SubscriptionsService from "subscriptions/api/SubscriptionsService";

import { Root, Summary, Block, Text, Digits } from "../styles";

const InsuranceRepresentative = ({ searchFilter }) => {
  const [summary, setSummary] = useState({
    activeSubscriptionsCount: 0,
    proPackageSubscriptionsCount: 0,
    globalPackageSubscriptionsCount: 0,
  });

  const subscriberType = "InsuranceRepresentative";

  const fetchSummary = async () => {
    const { data: { data } } = await SubscriptionsService.getSummaryInfo(subscriberType);

    setSummary(data);
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return (
    <Root>
      <Summary>
        <Block widthPercentage="34%">
          <Text>Total Active Subscribers</Text>
          <Digits>{summary.activeSubscriptionsCount}</Digits>
        </Block>
        <Block widthPercentage="33%">
          <Text>Pro Package</Text>
          <Digits>{summary.proPackageSubscriptionsCount}</Digits>
        </Block>
        <Block widthPercentage="33%">
          <Text>Global Package</Text>
          <Digits>{summary.globalPackageSubscriptionsCount}</Digits>
        </Block>
      </Summary>
      <SubscriptionsTable searchFilter={searchFilter} subscriberType={subscriberType} />
    </Root>
  );
};

export default InsuranceRepresentative;
